/* eslint-disable no-restricted-imports */
/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import React from 'react';
import { FC } from 'react';
import { Box, SxProps, Theme, Typography } from '@mui/material';
import { ProductType } from '@/data/types/Product';
import { usePriceToCheckDpOffer } from 'integration/utils/isDpOffer';

interface InfoElectronico {
	offerDeContado?: string;
	strikedDeContado?: string;
}

export const productSearchPriceSX = (hasDiscount: boolean): SxProps<Theme> => ({
	color: '#2C2C2C',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	textDecoration: hasDiscount ? 'line-through' : 'none',
});

export const productSearchDiscountSX: SxProps<Theme> = {
	color: '#AB2326',
	fontSize: 'var(--font-size-body)',
	fontWeight: '600',
	marginRight: '8px',
	textDecoration: 'none',
};

export const PriceProductSearch: FC<{
	product: ProductType;
	infoElectronico?: InfoElectronico;
}> = ({ product, infoElectronico }) => {
	const { discount, price } = usePriceToCheckDpOffer({ infoElectronico, product });

	return (
		<Box display={'flex'} flexDirection={'row'} flexWrap={'wrap'}>
			{discount ? <Typography sx={productSearchDiscountSX}>{discount}</Typography> : null}
			<Typography sx={productSearchPriceSX(discount !== null)}>{price}</Typography>
		</Box>
	);
};
